import SearchableInput, { IEntry } from "components/SearchableInput";
import { useApiInfo } from "hooks";
import React, { ChangeEvent, FC, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCategoriesByKeyword,
  setCategoriesEntries,
} from "store/actions/config.actions";
import { IState } from "store/store.interface";
import { CONFIG_GET_CATEGORIES } from "store/store.types";
import { debounce } from "lodash";

interface IProps {
  disable?: boolean,
  onChange?: (item: IEntry) => void;
  selectedItem?: string;
  label?: string;
  error?: string;
}
const Categories: FC<IProps> = ({ disable, onChange, selectedItem, label, error }) => {
  const { categories = [] } = useSelector((state: IState) => state.config);
  const { isLoading } = useApiInfo(CONFIG_GET_CATEGORIES);
  const dispatch = useDispatch();

  const debouncedGetCategories = useCallback(
    debounce((search: string) => {
      if (search) {
        dispatch(getCategoriesByKeyword(search));
      } else {
        dispatch(setCategoriesEntries([]));
      }
    }, 500),
    []
  );

  const onTypingHandler = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      debouncedGetCategories(event.target.value);
    },
    [debouncedGetCategories]
  );
  return (
    <SearchableInput
      disable={disable}
      entries={categories}
      onChange={onTypingHandler}
      label={label}
      onSelectItem={onChange}
      selectedItem={selectedItem}
      isLoading={isLoading}
      error={error}
    />
  );
};

Categories.defaultProps = {
  label: "Search for Categories ...",
};

export default Categories;
